module.exports = "/assets/data/fd776730a7dc65a67e2e38e62c18e542-LN9.data.json";